<template>
  <div class="list-table-inner">
    <div class="list-table-inner-header">
      <div class="search">
        <div class="search-add">
          <base-button
            class="add"
            icon
            size="sm"
            @click="addVehicle"
            v-if="$currentUserCan($permissions.PERM_CREATE_VEHICLES)"
          >
            <span class="btn-inner--icon">
              <i class="fa-regular fa-circle-plus"></i>
            </span>
            <span class="btn-inner--text">
              {{ $t("VEHICLES.ADD_VEHICLE") }}
            </span>
          </base-button>
        </div>
        <div class="search-form">
          <base-input
            v-model="query"
            type="search"
            prepend-icon="fal fa-search"
            :placeholder="$t('COMMON.SEARCH')"
            clearable
          />
          <button
            @click="
              () => {
                showAdvancedFilter = !showAdvancedFilter;
              }
            "
          >
            <i class="far fa-sliders-h"></i>
          </button>
        </div>
        <div>
          <base-button
            class="notification"
            type="info"
            icon
            size="sm"
            :title="$t('COMMON.SHOW_DELETED_ITEMS')"
            :class="{ active: onlyTrashed }"
            @click="onlyTrashed = !onlyTrashed"
          >
            <span class="btn-inner--icon">
              <i class="fa-light fa-trash"></i>
            </span>
          </base-button>
        </div>
        <!-- <notification-subscription
          v-if="$currentUserCan($permissions.PERM_VIEW_VEHICLES)"
          :objectType="'vehicles'"
          :events="{
            CREATE: $t('NOTIFICATIONS.EVENT_CREATE'),
            UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
            DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
          }"
        /> -->
      </div>
      <transition name="slide">
        <div class="advanced-search" v-if="showAdvancedFilter">
          <div class="advanced-search-item pagination-select">
            <el-select
              class="select-primary"
              v-model="pagination.perPage"
              :placeholder="$t('COMMON.PER_PAGE')"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
          <div
            class="advanced-search-item"
            v-if="
              !filterOrganization &&
              $currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)
            "
          >
            <organization-selector
              @organizationChanged="
                (organizationId) => (selectedOrganization = organizationId)
              "
            />
          </div>
          <div
            class="advanced-search-item"
            v-if="
              $currentUserCan($permissions.PERM_VIEW_ANY_LOCATIONS) && false
            "
          >
            <base-input :placeholder="`${$t('COMMON.LOCATIONS')}`">
              <fuel-types-selector
                @fuelTypesChanged="
                  (fuelTypes) => (selectedFuelTypes = fuelTypes)
                "
              />
            </base-input>
          </div>
          <div
            class="advanced-search-item"
            v-if="$currentUserCan($permissions.PERM_VIEW_ANY_VEHICLES)"
          >
            <years-selector
              :filterable="true"
              :value="selectedVehicleModelYear"
              @yearsChanged="
                (year) => {
                  selectedVehicleModelYear = year;
                }
              "
            />
          </div>
          <div
            class="advanced-search-item"
            v-if="$currentUserCan($permissions.PERM_VIEW_ANY_VEHICLES)"
          >
            <make-selector
              allow-none
              :year="selectedVehicleModelYear"
              :filterable="true"
              :placeholder="$t('VEHICLES.MAKE')"
              :value="selectedVehicleMake"
              @makeChanged="
                (make) => {
                  selectedVehicleMake = make;
                }
              "
            />
          </div>
          <div
            class="advanced-search-item"
            v-if="$currentUserCan($permissions.PERM_VIEW_ANY_VEHICLES)"
          >
            <model-selector
              allow-none
              :year="selectedVehicleModelYear"
              :filterable="true"
              :make="selectedVehicleMake"
              :value="selectedVehicleModel"
              @modelChanged="
                (model) => {
                  selectedVehicleModel = model;
                }
              "
            />
          </div>

          <div class="advanced-search-item d-inline-flex">
            <base-input
              :placeholder="$t('COMMON.ODOMETER_FROM')"
              v-model.number="odometer.from"
              type="number"
            />
            <base-input
              :placeholder="$t('COMMON.ODOMETER_TO')"
              v-model.number="odometer.to"
              type="number"
            />
            <!-- <el-select
              v-model="odometer_unit"
              :placeholder="$t('VEHICLES.ODOMETER_UNIT')"
            >
              <el-option value="km" :label="$t('ODOMETERS.KM')" />
              <el-option value="miles" :label="$t('ODOMETERS.MILES')" />
            </el-select> -->
          </div>
          <div
            class="advanced-search-item"
            v-if="
              $currentUserCan($permissions.PERM_VIEW_ANY_LOCATIONS) && false
            "
          >
            <base-input :placeholder="`${$t('COMMON.LOCATIONS')}`">
              <locations-selector
                @locationsChanged="
                  (locations) => (selectedLocations = locations)
                "
              />
            </base-input>
          </div>
          <div class="advanced-search-item update">
            <base-button class="add" icon size="sm" @click="resetFilters">
              <span class="btn-inner--icon">
                <i class="far fa-sync-alt"></i>
              </span>
              <span class="btn-inner--text">{{ $t("COMMON.RESET") }}</span>
            </base-button>
          </div>
        </div>
      </transition>
    </div>
    <div class="list-table-inner-body">
      <div class="list-table-inner-body-inner">
        <el-table
          class="align-items-center table-flush"
          header-row-class-name="thead-light has-image"
          :data="vehicles"
          @sort-change="sortChange"
          :row-class-name="setDeletedClass"
          @row-click="
            (row) => {
              viewVehicle(row);
            }
          "
        >
          <div class="table-loading" slot="empty" v-if="loading">
            <img src="/img/loading.gif" />
          </div>

          <el-table-column width="75">
            <template v-slot="{ row }">
              <div class="image">
                <img
                  v-if="row.gallery?.length > 0"
                  :src="row.gallery[0]"
                  class="avatar rounded-circle"
                />
                <span class="default-icon">
                  <i class="far fa-camera"></i>
                </span>
                <!--<span class="badge">3</span>-->
              </div>
            </template>
          </el-table-column>

          <el-table-column :label="$t('COMMON.VEHICLE')" min-width="250">
            <template v-slot="{ row }">
              <div class="vehicle">
                <ul class="no-line">
                  <li>{{ row.make }} {{ row.model }}</li>
                  <li>{{ row.model_year }}</li>
                </ul>
                <ul>
                  <li v-if="row.series">{{ row.series }}</li>
                  <li class="line" v-if="row.series">|</li>
                  <li v-if="row.color">{{ row.color }}</li>
                  <li class="line" v-if="row.color">|</li>
                  <li>{{ row.odometer ?? 0 }} {{ row.odometer_unit }}</li>
                </ul>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            :label="$t('VEHICLES.SKU') + ' / ' + $t('VEHICLES.VIN')"
            prop="sku"
            min-width="220"
          >
            <template v-slot="{ row }">
              <div class="stock">
                <ul>
                  <li v-if="row.sku">{{ row.sku }}</li>
                  <li><copy-element :element="row.vin" /></li>
                </ul>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            :label="$t('REPAIRS.CLIENT_WORK_ORDER')"
            prop="client"
            min-width="200"
          >
            <template v-slot="{ row }">
              <ul v-if="!!row.customer">
                <li>{{ $objectDenomination(row.customer) }}</li>
                <li>{{ row.customer?.phone }}</li>
              </ul>
              <span v-else> {{ $t("COMMON.INTERNAL") }} </span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('VEHICLES.DEPARTMENT')" min-width="180">
            <template>
              <span>{{ $t("VEHICLES.MECHANICAL") }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('COMMON.TASK')" min-width="150">
            <template v-slot="{ row }">
              <object-link
                v-if="row?.last_task && canViewTask(row.last_task?.type)"
                :object="row?.last_task"
                class=""
              >
                {{
                  $te(`COMMON.${row.last_task.type.slice(0, -1).toUpperCase()}`)
                    ? $t(
                        `COMMON.${row.last_task.type
                          .slice(0, -1)
                          .toUpperCase()}`
                      )
                    : row.last_task.type.slice(0, -1)
                }}
              </object-link>
              <span v-if="row?.last_task && !canViewTask(row.last_task?.type)">
                {{
                  $te(`COMMON.${row.last_task.type.slice(0, -1).toUpperCase()}`)
                    ? $t(
                        `COMMON.${row.last_task.type
                          .slice(0, -1)
                          .toUpperCase()}`
                      )
                    : row.last_task.type.slice(0, -1)
                }}
              </span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('COMMON.STATUS')" min-width="230">
            <template v-slot="{ row }">
              <div v-if="row?.last_task">
                <repair-status-badge
                  v-if="row.last_task.type == 'repairs'"
                  :repair="row.last_task"
                  :status="row.last_task.status"
                />
                <inspection-status-badge
                  v-if="row.last_task.type == 'inspections'"
                  :inspection="row.last_task"
                  :status="row.last_task.status"
                />
                <estimate-status-badge
                  v-if="row.last_task.type == 'estimations'"
                  :estimate="row.last_task"
                  :status="row.last_task.status"
                />
              </div>
            </template>
          </el-table-column>

          <!-- <el-table-column :label="$t('COMMON.DAYS')" min-width="150">
            <template v-slot="{ row }">
              <span>{{ row?.days }}</span>
            </template>
          </el-table-column> -->

          <el-table-column fixed="right" min-width="120">
            <div
              slot-scope="{ row }"
              class="table-actions"
              v-if="!isDeleted(row)"
            >
              <el-tooltip
                :content="$t('COMMON.VIEW')"
                placement="top"
                v-if="$currentUserCan($permissions.PERM_VIEW_VEHICLES)"
              >
                <a
                  type="text"
                  @click.stop="viewVehicle(row)"
                  class="table-action"
                  data-toggle="tooltip"
                >
                  <i
                    class="fa-light fa-arrow-up-right-and-arrow-down-left-from-center"
                  ></i>
                </a>
              </el-tooltip>

              <el-tooltip
                :content="$t('COMMON.DELETE')"
                placement="top"
                :class="{
                  disabled: !$currentUserCan($permissions.PERM_DELETE_VEHICLES),
                }"
              >
                <a
                  type="text"
                  @click.stop="deleteVehicle(row)"
                  class="table-action table-action-delete"
                  data-toggle="tooltip"
                >
                  <i class="fa-light fa-trash-can"></i>
                </a>
              </el-tooltip>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="list-table-inner-footer">
      <p class="card-category">
        {{
          $t("COMMON.DISPLAY_FROM_X_TO_X_OF_X_ENTRIES", {
            from: total ? from + 1 : 0,
            to: to,
            of: total,
          })
        }}

        <span v-if="selectedRows.length">
          &nbsp; &nbsp;
          {{ $t("COMMON.X_LINES_SELECTED", { count: selectedRows.length }) }}
        </span>
      </p>
      <base-pagination
        class="pagination-no-border"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      />
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { BasePagination } from "@/components";
import OrganizationSelector from "@/components/OrganizationSelector.vue";
import LocationsSelector from "@/components/LocationsSelector.vue";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import FuelTypesSelector from "@/components/FuelTypesSelector.vue";
import CopyElement from "@/components/CopyElement.vue";
import RepairStatusBadge from "@/views/Pages/InspectproModule/RepairManagement/partials/RepairStatusBadge.vue";
import InspectionStatusBadge from "@/views/Pages/InspectproModule/InspectionManagement/partials/InspectionStatusBadge.vue";
import EstimateStatusBadge from "@/views/Pages/InspectproModule/EstimateManagement/partials/EstimateStatusBadge.vue";
import trashedMixin from "@/mixins/trashed-mixin";
import YearSelector from "@/components/YearSelector.vue";
import YearsSelector from "@/components/YearsSelector.vue";
import MakeSelector from "@/components/MakeSelector.vue";
import ModelSelector from "@/components/ModelSelector.vue";

export default {
  name: "vehicle-list-table",

  components: {
    BasePagination,
    OrganizationSelector,
    LocationsSelector,
    FuelTypesSelector,
    CopyElement,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    NotificationSubscription,
    RepairStatusBadge,
    InspectionStatusBadge,
    EstimateStatusBadge,
    YearSelector,
    YearsSelector,
    MakeSelector,
    ModelSelector,
  },

  mixins: [requestErrorMixin, trashedMixin],

  props: {
    filterOrganization: {
      type: String,
      default: null,
      description: "organization id",
    },
  },

  data() {
    return {
      query: null,
      selectedRows: [],
      sort: "-updated_at",
      total: 0,
      pagination: {
        perPage: 20,
        currentPage: 1,
        perPageOptions: [20, 50, 100, 500],
      },
      vehicles: [],
      loading: true,
      selectedOrganization: null,
      selectedLocations: null,
      selectedFuelTypes: null,
      showAdvancedFilter: false,
      onlyTrashed: false,
      selectedVehicleModelYear: null,
      selectedVehicleMake: null,
      selectedVehicleModel: null,
      odometer: { from: null, to: null },
    };
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },

  methods: {
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      try {
        this.loading = true;
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.query ? { search: this.query } : {}),
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
          include: "organization,allowedLocations,customer",
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: { ...params.filter, organization: this.filterOrganization },
          };
        }
        if (this.selectedOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.selectedOrganization,
            },
          };
        }
        if (this.selectedLocations) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              allowedLocations: this.selectedLocations.map((loc) => loc.id),
            },
          };
        }
        if (this.selectedFuelTypes) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              fuel_type: this.selectedFuelTypes,
            },
          };
        }
        if (this.selectedVehicleModelYear) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              model_year: this.selectedVehicleModelYear,
            },
          };
        }
        if (this.selectedVehicleMake) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              make: this.selectedVehicleMake,
            },
          };
        }
        if (this.selectedVehicleModel) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              model: this.selectedVehicleModel,
            },
          };
        }
        if (this.odometer.from) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              odometer_from: this.odometer.from,
            },
          };
        }
        if (this.odometer.to) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              odometer_to: this.odometer.to,
            },
          };
        }
        if (this.onlyTrashed) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              only_trashed: true,
            },
          };
        }

        await this.$store.dispatch("vehicles/list", params);
        this.vehicles = this.$store.getters["vehicles/list"];
        this.total = this.$store.getters["vehicles/listTotal"];
        this.loading = false;
      } catch (error) {
        this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    addVehicle() {
      this.$emit("onAddVehicle");
    },

    deleteVehicle(vehicle) {
      this.$emit("onDeleteVehicle", vehicle);
    },

    viewVehicle(vehicle) {
      if (this.isDeleted(vehicle)) {
        return;
      }
      this.$emit("onViewVehicle", vehicle);
    },

    editVehicle(vehicle) {
      this.$emit("onEditVehicle", vehicle);
    },

    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.getList();
    },

    canViewTask(taskType = null) {
      if (taskType == "inspections") {
        return (
          this.$currentUserCan(
            this.$permissions.PERM_VIEW_MODULE_INSPECTIONS
          ) && this.$currentUserCan(this.$permissions.PERM_VIEW_INSPECTIONS)
        );
      }
      if (taskType == "estimations") {
        return (
          this.$currentUserCan(
            this.$permissions.PERM_VIEW_MODULE_ESTIMATIONS
          ) && this.$currentUserCan(this.$permissions.PERM_VIEW_ESTIMATIONS)
        );
      }
      if (taskType == "repairs") {
        return (
          this.$currentUserCan(this.$permissions.PERM_VIEW_MODULE_REPAIRS) &&
          this.$currentUserCan(this.$permissions.PERM_VIEW_REPAIRS)
        );
      }

      return false;
    },

    resetFilters() {
      this.query = null;
      this.selectedRows = [];
      this.sort = "-updated_at";
      this.total = 0;
      this.vehicles = [];
      this.loading = true;
      this.selectedOrganization = null;
      this.selectedLocations = null;
      this.selectedFuelTypes = null;
      this.onlyTrashed = false;
      this.selectedVehicleModelYear = null;
      this.selectedVehicleMake = null;
      this.selectedVehicleModel = null;
      this.odometer = { from: null, to: null };
      this.pagination.perPage = 20;
    },
  },

  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
    onlyTrashed: {
      handler: "getList",
      immediate: true,
    },
    filterOrganization: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedOrganization: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedLocations: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedFuelTypes: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedVehicleModelYear: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedVehicleMake: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedVehicleModel: {
      handler: "getListDebounced",
      immediate: true,
    },
    odometer: {
      handler: "getListDebounced",
      immediate: true,
      deep: true,
    },
  },
};
</script>
